var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 609 609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(.99924 0 0 -.99924 0 607)",
    gradientUnits: "userSpaceOnUse",
    id: "a",
    x1: 107,
    x2: 502,
    y1: 105,
    y2: 500
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5a87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6bf09"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305 558h304v51H305zm0 0",
    fill: "#ffcf2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305 0a304 304 0 1 0 0 609 304 304 0 0 0 0-609zm0 558a254 254 0 1 1 0-507 254 254 0 0 1 0 507zm0 0",
    fill: "#ffd86c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M305 25a279 279 0 1 0 0 559 279 279 0 0 0 0-559zM100 238a63 63 0 1 1 40 80 64 64 0 0 1-40-80zm167 227a63 63 0 1 1-103-75 63 63 0 0 1 103 75zm-26-313a63 63 0 1 1 127 0 63 63 0 0 1-127 0zm191 327a63 63 0 1 1-75-103 63 63 0 0 1 75 103zm37-161a63 63 0 1 1 41-80c11 33-8 69-41 80zm0 0",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355 305a51 51 0 1 1-101 0 51 51 0 0 1 101 0zm0 0",
    fill: "#ffdc66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.6240d70e79a44a01ac007acea3dba3b8.svg";
export { ForwardRef as ReactComponent };